import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/SunLoan.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
//import { createBrowserHistory } from 'history';
import { history } from './_helpers';
import { store } from './_helpers';
import { App } from './App';
import { unregister } from './registerServiceWorker';



// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
//const initialState = window.initialReduxState;
//const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    rootElement);
/*
ReactDOM.render(
    <Provider store={store}>
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter></Provider>,
  rootElement);
  */
//registerServiceWorker();
unregister();
